import type { TowerDesign } from "@/game/towerSpec";
import type { Material } from "@/physics/model";
const A572_65: Material = { name: "A572 Gr65", E: 200e9, Fy: 448e6, rho: 7850 };
/** UK planning drawing, 12.5 m slim monopole. ODs estimated base ~0.6m/top ~0.3m. */
export const design: TowerDesign = {
  id: "monopole-uk-princessrd-12m",
  name: "Monopole (Princess Rd 12.5 m, UK)",
  description: "Real 12.5 m monopole, Princess Rd UK (planning drawing).",
  author: "reference: 02_engineering_drawings",
  spec: {
    type: "monopole",
    height: 12.5,
    stack: { faces: 12, panels: 6, baseRadius: 0.3, topRadius: 0.15,
      legSection: "legXXL", braceSection: "braceHeavy", legMaterial: A572_65, braceMaterial: A572_65, bracing: "X" },
    shell: { baseDiameter: 0.6, topDiameter: 0.3 },
    foundation: { soil: "dense-sand",
      base: { type: "pier", width: 1.5, diameter: 1.5, depth: 3.5, concrete: "c30" },
      connection: { kind: "anchorBolts", nBolts: 12, bolt: "b1_75", grade: "f1554_105", boltCircleDia: 1.2, embedment: 0.45, edgeDistance: 0.3, platePlanArea: 1.8, plateThickness: 0.05, plateGrade: "a36rod", fc: 30e6 } },
  },
};
